module.exports = __webpack_public_path__ + "static/img/kongxiaoli.ae443637.jpg";